<template>
    <div class="has-text-left">
        <b-modal :active.sync="escalateModalOpen" id="escalatemodal" aria-modal :width="800" scroll="keep" :can-cancel="false">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ escalationName == 'escalatie' ? 'Facturen escaleren' : 'Facturen sturen naar deurwaarder' }}</p>
            </header>
            <section class="modal-card-body" style="border-radius:0;">
                <p>Wanneer een factuur {{ escalationName == 'escalatie' ? 'escaleert' : 'naar de deurwaarder wordt gestuurd' }}, worden eventuele open betalingen geannuleerd. De factuur is dan te vinden in de navigatie onder 'Facturen > {{ escalationName == 'escalatie' ? 'Geëscaleerd' : 'Deurwaarder' }}'.</p>

                <p>Bij escalatie wordt er automatisch een {{ escalationName == 'escalatie' ? 'escalatie' : '' }}pakket gegenereerd. Dit pakket, in de vorm van een zip-bestand, bevat de factuur, eventuele contracten en de communicatielog.</p>

                <h6><strong>{{ escalationName == 'escalatie' ? 'Escalatie' : 'Deurwaarder' }} opties</strong></h6>
                <p>
                    <ul>
                        <li><strong>Intern escaleren:</strong> Na interne escalatie dien je zelf verdere acties te ondernemen met het automatisch gegenereerde {{ escalationName == 'escalatie' ? 'escalatie' : '' }}pakket.</li>
                        <li><strong>Deurwaarder:</strong> De factuur {{ escalationName == 'escalatie' ? 'wordt geëscaleerd' : 'krijgt de status "deurwaarder"' }}, en het {{ escalationName == 'escalatie' ? 'escalatie' : '' }}pakket wordt automatisch gemaild naar het ingestelde deurwaarderskantoor voor verdere procedures. De klant krijgt een notificatie per e-mail dat de factuur {{ escalationName == 'escalatie' ? 'geëscaleerd' : 'naar de deurwaarder gestuurd' }} is.&nbsp;<b-tooltip label="Onvoldoende rechten of ontbrekende instellingen." v-if="!showOutEscalation"><b-tag type="is-danger">Niet mogelijk <b-icon size="is-small" icon="info-circle" /></b-tag></b-tooltip></li>
                    </ul>
                </p>

                <div v-if="showEscalation">
                    <p>Selecteer de facturen die je {{ escalationName == 'escalatie' ? 'wil laten escaleren' : 'naar de deurwaarder wil sturen' }}.</p>

                    <b-message type="is-info" v-if="!eligableInvoices">
                        <p>Er zijn geen facturen gevonden die {{ escalationName == 'escalatie' ? 'geëscaleerd' : 'verstuurd' }} kunnen worden.</p>
                    </b-message>

                    <b-table
                        :data="invoices"
                        :checked-rows.sync="selectedInvoices"
                        :checkable="true"
                        checkbox-position="left"
                        checkbox-type="is-primary"
                        :striped="true"
                        :loading="loading"
                        :mobile-cards="true"
                        class="invoice-escalate-modal"
                        v-else
                    >
                        <template>
                            <b-table-column v-slot="props" field="number" label="Factuur nr." width="160">
                                {{ props.row.number }}
                            </b-table-column>

                            <b-table-column v-slot="props" field="status" label="Status" width="200" sortable>
                                <InvoiceStatus
                                    :id="props.row.id"
                                    :status="props.row.status"
                                    :send_at="props.row.send_at"
                                    :contract="props.row.contract"
                                />
                            </b-table-column>

                            <b-table-column v-slot="props" field="total_price" label="Totaal" width="180">
                                <span v-if="props.row.total">€&nbsp;{{ props.row.total }}</span>
                                <span v-else>-</span>
                            </b-table-column>

                            <b-table-column v-slot="props" label="Factuur datum" width="240" sortable>
                                <span>{{ props.row.invoice_date|humanDate }}</span>
                            </b-table-column>
                        </template>
                    </b-table>

                    <div id="invoice-logs" ref="invoicelogs" v-if="selectedInvoices.length" style="display:none;">
                        <InvoiceLog
                            v-for="log in selectedInvoices[loopInvoiceNumber].invoice_logs"
                            :key="'invoicelog_'+log.id"
                            :log="log"
                            :hidebuttons="true"
                        />
                    </div>
                </div>
                <div v-else>
                    {{ escalationName == 'escalatie' ? 'Escaleren' : 'Versturen naar deurwaarder is' }} niet mogelijk. Controleer je organisatie instellingen.
                </div>

                <b-field v-if="hasContract">
                    <b-checkbox v-model="autoEscalate">
                        Automatisch nieuwe facturen in dit contract escaleren wanneer ze worden aangemaakt.
                    </b-checkbox>
                </b-field>
            </section>

            <footer class="modal-card-foot">
                <b-button type="is-light" @click="escalateModalOpen = false" :disabled="loading">Annuleren</b-button>
                <span v-if="eligableInvoices && showEscalation">
                    <b-button type="is-dark" @click="escalate()" :loading="loading" :disabled="loading || !selectedInvoices.length">Intern escaleren</b-button>
                    <b-button type="is-danger" v-if="showOutEscalation" @click="escalate(true)" :loading="loading" :disabled="loading || !selectedInvoices.length">Deurwaarder</b-button>
                </span>
            </footer>
        </b-modal>

        <b-modal :active.sync="cancelContractModalOpen">
            <header class="modal-card-head">
                <p class="modal-card-title">Contract annuleren</p>
            </header>
            <section class="modal-card-body" style="border-radius:0;">
                <p>{{ escalationName == 'escalatie' ? 'Escalatie voltooid. De factuur is succesvol geëscaleerd.' : 'Factuur is succesvol naar de deurwaarder gestuurd.' }} Wil je ook het bijbehorende contract beëindigen?</p>
            </section>
            <footer class="modal-card-foot">
                <b-button type="is-light" @click="cancelContractModalOpen = false" :disabled="loading">Nee, sluiten</b-button>
                <b-button type="is-dark" @click="cancelContract" :loading="loading" :disabled="loading">Ja, contract beëindigen</b-button>
            </footer>
        </b-modal>
    </div>
</template>

<script>
import filtersMixin from '@/mixins/filterMixins'
import InvoiceLog from './InvoiceLog'

export default {
    name: 'InvoiceEscalateModals',

    mixins: [filtersMixin],

    components: {
        InvoiceLog
    },

    props: {
        showEscalation: {
            type: Boolean,
            default: false
        },

        showOutEscalation: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            escalateModalOpen: false,
            cancelContractModalOpen: false,
            invoices: [],
            selectedInvoices: [],
            eligableInvoices: true,
            loopInvoiceNumber: 0,
            autoEscalate: false,
            hasContract: false
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        escalationName() {
            return _.has(this.user, 'organisation_settings.escalation_name') ? this.user.organisation_settings.escalation_name : 'escalatie'
        }
    },

    methods: {
        fetchPossibleEscalations(payload) {
            this.loading = true
            this.selectedInvoices = []
            this.loopInvoiceNumber = 0

            axios.get(`/api/invoices`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken},
                params: payload
            }).then((response) => {
                this.invoices = response.data.data

                // Select requested invoice
                if (_.has(payload, 'esc_invoice') && !_.isNull(payload.esc_invoice)) {
                    const requestedInvoice = _.findKey(this.invoices, {id: payload.esc_invoice})
                    if (requestedInvoice) {
                        this.selectedInvoices.push(this.invoices[requestedInvoice])
                    }
                }

                if (this.invoices.length == 0) {
                    this.eligableInvoices = false
                }
            }).catch((error) => {
                console.error('[❌] Error while fetching possible escalations for invoice', error)
                this.$buefy.toast.open({
                    message: 'Daar gaat iets fout. Probeer het opnieuw.',
                    type: 'is-danger'
                })
            }).then(() => {
                this.loading = false
            })
        },

        toggleEscalateModal(payload = false) {
            // Reset all when opening
            if(!this.escalateModalOpen) {
                this.invoices = []
                this.selectedInvoices = []
                this.eligableInvoices = true
                this.loopInvoiceNumber = 0
            }
            if (payload && !!payload.esc_contract) {
                this.hasContract = true
            }

            this.escalateModalOpen = !this.escalateModalOpen;

            if (payload) {
                this.fetchPossibleEscalations(payload)
            }
        },

        escalate(deurwaarder = false) {
            this.loading = true

            this.parseLogMessages().then(() => {
                axios.post(`/api/invoices/escalate`, {
                    invoices: this.selectedInvoices,
                    deurwaarder,
                    auto_escalate: this.autoEscalate
                }, {
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken},
                }).then((response) => {
                    this.$emit('escalated')

                    if (!!response.data.cancelContract) {
                        this.toggleEscalateModal() // close current modal
                        this.toggleContractModal() // show cancel contract modal
                    } else {
                        // Redirect to invoice overview 'geëscaleerd'.
                        this.$buefy.toast.open({
                            message: `${this.selectedInvoices.length > 1 ? 'Facturen' : 'Factuur'} succesvol geëscaleerd!`,
                            type: 'is-success'
                        })

                        this.$router.push({ name: 'InvoicesOverview', params: {type: 'geescaleerd'} })
                    }
                }).catch((error) => {
                    console.error('[❌] Error while escalating invoices', error)
                    this.$buefy.toast.open({
                        message: 'Daar gaat iets fout. Probeer het opnieuw.',
                        type: 'is-danger'
                    })
                }).then(() => {
                    this.$store.dispatch('fetchInvoicesNeedsAction') // refresh invoice needs action count
                    this.loopInvoiceNumber = 0
                    this.loading = false
                })
            })
        },

        // Parse log messages to HTML
        parseLogMessages() {
            return new Promise((resolve) => {
                this.selectedInvoices.forEach((invoice, index) => {
                    invoice.parsed_invoice_logs = this.$refs['invoicelogs'].innerHTML

                    if ((index + 1) === this.selectedInvoices.length) {
                        resolve()
                        this.loopInvoiceNumber = 0
                    } else {
                        this.loopInvoiceNumber++
                    }
                })
            })
        },

        cancelContract() {
            const contractID = this.selectedInvoices[0].contract.id

            // Redirect to contract record trigger cancelcontract modal
            this.$router.push({name: 'ContractsRecordView', params: {id: contractID}, query: {cancel: true}})
        },

        toggleContractModal() {
            this.cancelContractModalOpen = !this.cancelContractModalOpen;
        }
    }
}
</script>